import projection from '../generated/pwp503f1.json';
import { AcceptanceManifest } from '../types';

export const pwp503f1AcceptanceManifest = projection as AcceptanceManifest;
